const variants = {
  stat: "warning",
  routine: "info",
  urgent: "danger",
  asap: "warning"
};

/**
 * Maps a priority string to a Bootstrap variant.
 * @param {string} priority
 * @returns {string}
 */
function getPriorityVariant(priority) {
  return variants[priority?.toLowerCase()] || "secondary";
}

export { getPriorityVariant };